import { pct } from '../../lib/format';
import type { ColdStats } from '../../lib/data';

export function Kpis({ s }: { s: ColdStats }) {
  const t = s.today;
  return (
    <div className="kpis" aria-label="Calls today">
      <div className="card kpi">
        <div className="k">Dials today</div>
        <div className="v">
          {t.dials} <small>/ {s.target}</small>
        </div>
        <div className="meter">
          <i style={{ width: `${Math.min(100, (t.dials / Math.max(1, s.target)) * 100)}%` }} />
        </div>
      </div>
      <div className="card kpi">
        <div className="k">Reached</div>
        <div className="v">{t.reached}</div>
        <div className="s">{pct(t.reached, t.dials)} connect rate</div>
      </div>
      <div className="card kpi">
        <div className="k">Conversations</div>
        <div className="v">{t.conversations}</div>
        <div className="s">Owner or decision-maker</div>
      </div>
      <div className="card kpi">
        <div className="k">Booked</div>
        <div className="v">{t.booked}</div>
        <div className="s">{pct(t.booked, t.conversations)} of conversations</div>
      </div>
    </div>
  );
}
